import { render, staticRenderFns } from "./ModalPricingRules.vue?vue&type=template&id=0e4ba5a4"
import script from "./ModalPricingRules.vue?vue&type=script&lang=js"
export * from "./ModalPricingRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports